import axios from './axios-instance'

export default {
  all ({ q = '' }) {
    return axios.get(`/v1/exercise_technics?q=${q}`)
  }
}
